import StatusBadge from 'components/badges/StatusBadge';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ReadyStatusBadge: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => {
    const { READY } = useTranslation();

    return (
        <StatusBadge
            className={`${className} ${styles.readyStatusBadge}`}
            testId={testId}
            text={text ?? READY}
        />
    );
};

export default ReadyStatusBadge;
